/* Pick & Pluck theme JS — AJAX cart + wishlist helpers */
(function () {
  'use strict';

  const PP = (window.PickPluck = window.PickPluck || {});

  /* ---------- Toast ---------- */
  PP.toast = function (message, type) {
    let host = document.getElementById('pp-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'pp-toast-host';
      host.className = 'fixed bottom-5 left-1/2 z-[100] flex w-full max-w-sm -translate-x-1/2 flex-col items-center gap-2 px-4';
      document.body.appendChild(host);
    }
    const el = document.createElement('div');
    el.className =
      'w-full rounded-xl px-4 py-3 text-sm font-medium text-white shadow-lg transition-opacity duration-300 ' +
      (type === 'error' ? 'bg-red-600' : 'bg-brand-green');
    el.textContent = message;
    host.appendChild(el);
    setTimeout(() => {
      el.style.opacity = '0';
      setTimeout(() => el.remove(), 350);
    }, 2500);
  };

  /* ---------- Cart ---------- */
  PP.updateCartCount = async function () {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const link = document.querySelector('a[aria-label="Cart"]');
      if (!link) return cart;
      let badge = link.querySelector('[data-cart-count]');
      if (!badge) {
        badge = document.createElement('span');
        badge.setAttribute('data-cart-count', '');
        badge.className =
          'absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-brand-orange px-1 text-[10px] font-bold text-white';
        link.appendChild(badge);
      }
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      return cart;
    } catch (e) {
      return null;
    }
  };

  PP.addToCart = async function (items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }
    await PP.updateCartCount();
    return res.json();
  };

  /* Intercept forms marked data-ajax-cart */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const id = form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
    if (!id) return;
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      await PP.addToCart([{ id: parseInt(id, 10), quantity: qty }]);
      PP.toast('Added to your basket');
    } catch (err) {
      PP.toast(err.message, 'error');
    } finally {
      if (btn) btn.disabled = false;
    }
  });


  /* ---------- Facet filters (Shopify native storefront filtering) ---------- */
  /* Checkbox changes submit the filter form immediately. Empty inputs are
     stripped so the URL stays clean. Price inputs submit on Enter/Apply. */
  function submitFacetForm(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== null && String(value).trim() !== '') params.append(key, value);
    });
    const base = window.location.pathname;
    const qs = params.toString();
    window.location.href = qs ? base + '?' + qs : base;
  }

  document.addEventListener('change', function (e) {
    const form = e.target.closest('form[data-facet-form]');
    if (!form) return;
    if (e.target.type !== 'checkbox') return;
    submitFacetForm(form);
  });

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-facet-form]');
    if (!form) return;
    e.preventDefault();
    submitFacetForm(form);
  });


  /* ---------- Product recommendations (Shopify Recommendations API) ---------- */
  function loadRecommendations() {
    var host = document.querySelector('[data-product-recommendations]');
    if (!host || !host.dataset.url) return;
    fetch(host.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner && inner.innerHTML.trim()) {
          host.innerHTML = inner.innerHTML;
          PP.refreshIcons();
          PP.refreshJudgeMe();
        } else {
          host.remove();
        }
      })
      .catch(function () { host.remove(); });
  }

  /* ---------- Recently viewed products ---------- */
  var RV_KEY = 'pp_recently_viewed';

  function money(cents) { return '£' + (cents / 100).toFixed(2); }

  function trackRecentlyViewed() {
    var host = document.querySelector('[data-recently-viewed]');
    if (!host) return;
    var handle = host.dataset.handle;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}

    var toShow = list.filter(function (h) { return h !== handle; }).slice(0, 4);
    var grid = host.querySelector('[data-recently-viewed-grid]');

    if (toShow.length === 0) {
      host.remove();
    } else if (grid) {
      Promise.all(
        toShow.map(function (h) {
          return fetch('/products/' + h + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        var cards = products.filter(Boolean).map(function (p) {
          var img = p.featured_image
            ? '<img src="' + p.featured_image + '&width=400" alt="" class="h-full w-full object-contain p-3" loading="lazy">'
            : '';
          return (
            '<a href="' + p.url + '" class="group flex h-full flex-col overflow-hidden rounded-2xl bg-gray-100">' +
              '<span class="flex aspect-[3/2] items-center justify-center overflow-hidden bg-gray-100">' + img + '</span>' +
              '<span class="flex flex-1 flex-col p-4">' +
                '<span class="line-clamp-2 text-lg font-medium leading-snug text-brand-green">' + p.title + '</span>' +
                '<span class="mt-3 text-2xl font-semibold text-brand-green">' + money(p.price) + '</span>' +
              '</span>' +
            '</a>'
          );
        });
        if (cards.length) grid.innerHTML = cards.join('');
        else host.remove();
      });
    }

    list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
    localStorage.setItem(RV_KEY, JSON.stringify(list));
  }

  /* Re-render Judge.me badges after dynamic content is injected */
  PP.refreshJudgeMe = function () {
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
  };

  /* ---------- Wishlist (localStorage) ---------- */
  const WKEY = 'pp_wishlist';

  PP.getWishlist = function () {
    try {
      return JSON.parse(localStorage.getItem(WKEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  PP.inWishlist = function (handle) {
    return PP.getWishlist().includes(handle);
  };

  PP.toggleWishlist = function (handle) {
    let list = PP.getWishlist();
    if (list.includes(handle)) {
      list = list.filter((h) => h !== handle);
      PP.toast('Removed from wishlist');
    } else {
      list.push(handle);
      PP.toast('Saved to wishlist');
    }
    localStorage.setItem(WKEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('pp:wishlist-changed', { detail: { list } }));
    return list;
  };

  /* Wishlist toggle buttons: <button data-wishlist-toggle="handle"> */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-wishlist-toggle');
    PP.toggleWishlist(handle);
    syncWishlistButtons();
  });

  function syncWishlistButtons() {
    const list = PP.getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = list.includes(btn.getAttribute('data-wishlist-toggle'));
      btn.classList.toggle('is-wishlisted', active);
      const svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', active ? 'currentColor' : 'none');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistButtons();
    PP.updateCartCount();
    /* Product form opts into AJAX cart (set here because Liquid's form tag
       cannot emit hyphenated attributes). */
    const pform = document.getElementById('pp-product-form');
    if (pform) pform.setAttribute('data-ajax-cart', '');
    loadRecommendations();
    trackRecentlyViewed();
  });
  document.addEventListener('pp:wishlist-changed', syncWishlistButtons);

  /* Re-render lucide icons after Alpine mutations (dynamic content) */
  PP.refreshIcons = function () {
    if (window.lucide) window.lucide.createIcons();
  };
})();
